<template>
<div>
  <div class="list-group">
    <draggable v-model="all">
      <transition-group>
        <button
          v-for="item in all"
          :key="item.id"
          type="button"
          class="list-group-item"
        >{{item.text}}</button>
      </transition-group>
    </draggable>
  </div>
  <btn @click="fetch()">重置</btn>
  <btn @click="save" type="primary">保存</btn>
</div>
</template>

<script>
import * as TYPES from '../store/types'
import draggable from 'vuedraggable'

export default {
  components: {
    draggable
  },
  data() {
    return {
      all: []
    }
  },
  methods: {
    fetch() {
      this.$store.dispatch(TYPES.DO_GET_ALL_BRANDS).then(res => {
        this.all = res.data.data
      })
    },
    save() {
      let all = this.all.map((val, index) => {
        val.viewIndex = index
        return val
      })
      console.log(all)
      this.$store.dispatch(TYPES.ORDER_BRANDS, all)
      .then(res => {
        this.$notify({
          type: 'success',
          content: '保存成功'
        })
      })
      .catch(res => {
        this.$notify({
          type: 'danger',
          content: '保存失败'
        })
      })
    }
  },
  created() {
    this.fetch()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/ViewIndexBrand.vue